import React from 'react'
import DetailCard from '../Main/DetailCard'

const value = {
  id: 1,
  heading: "Scissor Lift Pallet Truck",
  intro : [
    "Scissor Lift Truck designed to load and unload conveyor, feed presses, or any applications requiring moving and positioning pallets or containers of materials. Scissor mechanism gives it required strength.",
  ],
  features: [
    "Improved Safety: Automatic activation of self-adjusting stabilizers when lifting loads higher than 400 mm for maximum stability.",
    "Stability: Extra-long front legs increase the, Stability when handling unevenly loaded pallets. When lifting height below 400 mm, it is an easy to move as a pallet truck, above 400 mm the truck is automatically locked by triggering the supports at both sides of the steering wheels.",
  ],
  imageUrl: "/images/scissor.png"
}

const ScissorTrolley = () => {
  return (
  <>
  <DetailCard lists={value} />
  </>
  )
}

export default ScissorTrolley